import { render, staticRenderFns } from "./EmAclRoleList.vue?vue&type=template&id=5ca22cfa&"
import script from "./EmAclRoleList.vue?vue&type=script&lang=js&"
export * from "./EmAclRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports